import React, { ReactNode } from 'react';
import { Stack } from '../Stack/Stack';
import { t } from '../../locales/translate';
import NoDataImage from '../../assets/no_data.svg';

interface Props {
  description?: ReactNode;
}

export function NoData({ description }: Props): JSX.Element {
  return (
    <Stack justify="center" size="xxs">
      <img src={NoDataImage} className="no-data__img" />
      <p className="no-data__text">{description ?? t.general.noDataToShow}</p>
    </Stack>
  );
}
